import IdForm from "@/components/forms/idForm/IdForm";
import InformationBox from "@/components/InformationBox/InformationBox";
import QuitRegistration from "@/components/QuitProcess";
import { usePrismic } from "@/hooks/usePrismic";
import { chatBot } from "@/libs/chatBot";
import { css } from "@emotion/react";
import { useEffect } from "react";

export const SelfRegistrationLogin = () => {
  const t = usePrismic();

  useEffect(() => {
    if (window.location.pathname.includes("auto-gestion")) {
      chatBot.setChatVariable("seccion", "1");
    }
  }, []);

  return (
    <div className="center">
      <InformationBox
        hide={true}
        text={t.constants.ADVERTENCIALOGIN}
        boldText={t.constants.TENPRESENTE}
        icon="info"
        extraCss={css`
          padding: 0.3rem 0;
          margin: 1rem auto;
          .svgContainer {
            margin: 0.3em;
          }
        `}
      />

      <IdForm
        quitLink={<QuitRegistration />}
        navigationPath={"/auto-gestion/inscripcion-digital"}
      />
    </div>
  );
};
